import styles from './BottomNav.module.css';
import logo from '../../assets/icons/cm_logo.svg';
import MenuIcon from '@mui/icons-material/Menu';

const BottomNav = ({ onMenuClick }) => {
  return (
    <nav className={styles.bottomNav} aria-label="Mobile navigation">
      <img
        src={logo}
        alt="Cliqmetrics Logo"
        className={styles.logo}
      />
      <button className={styles.navButton} onClick={onMenuClick} aria-label="Menu">
        <MenuIcon />
      </button>
    </nav>
  );
};

export default BottomNav;
